import { Enrolment } from '@/models/enrolment';

export class EnrolmentSelectionReplacedEventPayload {
	public constructor(
		public readonly currentSelection: Readonly<Enrolment[]>,
		public readonly previousSelection: Readonly<Enrolment[]>
	) {}
}
